"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pixi_js_1 = require("pixi.js");
const gsap_1 = __importDefault(require("gsap"));
const colors = [0xf48c06, 0xfaa307, 0xffba08];
class PhoenixFlame {
    constructor(app) {
        this.app = app;
        this.particles = [];
        this.woodEmoji = new pixi_js_1.Text('');
        this.app.stage.addChild(this.woodEmoji);
        this.addWood();
        this.createParticleEmitter();
    }
    addWood() {
        this.woodEmoji.text = `🪵`;
        this.woodEmoji.style = new pixi_js_1.TextStyle({ fontSize: 128 });
        this.woodEmoji.x = this.app.renderer.width / 2 - 72;
        this.woodEmoji.y = this.app.renderer.height / 2;
    }
    createParticleEmitter() {
        this.emitIntervalId = window.setInterval(() => {
            for (let i = 0; i < PhoenixFlame.TOTAL_PARTICLES; i++) {
                this.emitParticle();
            }
        }, PhoenixFlame.EMIT_INTERVAL);
    }
    emitParticle() {
        const particle = new pixi_js_1.Graphics();
        const size = PhoenixFlame.PARTICLE_SIZE_MIN + Math.random() * (PhoenixFlame.PARTICLE_SIZE_MAX - PhoenixFlame.PARTICLE_SIZE_MIN);
        const color = colors[Math.floor(Math.random() * colors.length)];
        const randomRangeX = Math.floor(Math.random() * 41) - 20;
        const randomRangeY = Math.floor(Math.random() * 41) - 20;
        particle.beginFill(color);
        particle.drawCircle(0, 0, Math.floor(Math.random() * size));
        particle.endFill();
        particle.position.set(this.app.renderer.width / 2 + randomRangeX, this.app.renderer.height / 2 + randomRangeY);
        this.app.stage.addChild(particle);
        this.particles.push(particle);
        // Calculate a random angle between 45 and 135 degrees
        const angle = 45 + Math.random() * 90;
        const radians = (-angle * Math.PI) / 180;
        const distance = PhoenixFlame.DISTANCE_MAX + Math.random() * PhoenixFlame.DISTANCE_MIN; // Random distance between 150 and 220
        // Calculate target position based on angle
        const targetX = particle.position.x + Math.cos(radians) * distance;
        const targetY = particle.position.y + Math.sin(radians) * distance;
        gsap_1.default.to(particle.position, {
            x: targetX,
            y: targetY,
            duration: PhoenixFlame.ANIMATION_DURATION,
            onComplete: () => {
                this.app.stage.removeChild(particle);
                this.particles = this.particles.filter(p => p !== particle);
            }
        });
        // Fade out the particle
        gsap_1.default.to(particle, {
            alpha: 0,
            duration: PhoenixFlame.ANIMATION_DURATION,
            onComplete: () => {
                this.app.stage.removeChild(particle);
                this.particles = this.particles.filter(p => p !== particle);
            }
        });
    }
    destroy() {
        // Clear all particles from the stage and stop their animations
        this.particles.forEach(particle => {
            gsap_1.default.killTweensOf(particle);
            this.app.stage.removeChild(particle);
            particle.destroy();
        });
        this.particles = [];
        // Clear the interval to stop emitting new particles
        if (this.emitIntervalId !== undefined) {
            clearInterval(this.emitIntervalId);
        }
        // Remove text display from the stage and destroy it
        this.app.stage.removeChild(this.woodEmoji);
        this.woodEmoji.destroy();
    }
}
exports.default = PhoenixFlame;
PhoenixFlame.TOTAL_PARTICLES = 70;
PhoenixFlame.PARTICLE_SIZE_MIN = 3;
PhoenixFlame.PARTICLE_SIZE_MAX = 15;
PhoenixFlame.DISTANCE_MIN = 70;
PhoenixFlame.DISTANCE_MAX = 150;
PhoenixFlame.EMIT_INTERVAL = 90;
PhoenixFlame.ANIMATION_DURATION = 1.5;
